export default ({
  path: "/services",
  name: "services",
  component: () => import("@/views/service/Service.vue"),
  meta: {
    title: "Services - Self-Assessment and Quality Improvement Planning Portal"
  },
  children: [
    {
      path: "dashboard",
      name: "service-dashboard",
      component: () => import("@/views/service/ServiceDashboard.vue"),
      meta: {
        protected: true,
        title: "Service - Self-Assessment and Quality Improvement Planning Portal"
      }
    },
    {
      path: "register",
      name: "service-register",
      component: () => import("@/views/service/ServiceRegister.vue"),
      meta: {
        protected: true,
        requiresVerifiedDirector: true,
        title: "Service - Self-Assessment and Quality Improvement Planning Portal"
      }
    },
    {
      path: "verify",
      name: "service-verify",
      component: () => import("@/views/service/ServiceVerify.vue"),
      meta: {
        protected: true,
        requiresVerifiedDirector: true,
        title: "Service - Self-Assessment and Quality Improvement Planning Portal"
      }
    }
  ]
}
)
